import { render, staticRenderFns } from "./CategoryDialog.vue?vue&type=template&id=13706972&scoped=true"
import script from "./CategoryDialog.vue?vue&type=script&lang=js"
export * from "./CategoryDialog.vue?vue&type=script&lang=js"
import style0 from "./CategoryDialog.vue?vue&type=style&index=0&id=13706972&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13706972",
  null
  
)

export default component.exports